module.exports = __webpack_public_path__ + "static/media/Joe Kappes.14c7126f.png";